import React from "react";
import _ from "lodash";
import { FormFieldProps, readValue } from "@my-dld/components/Form/FormField";

export interface IPrivateSellForm<P extends IPrivateSellFormProps, S extends IPrivateSellFormState> extends React.Component<P, S> {
	isValid: ( isUserAction?: boolean ) => boolean;
}

export interface IPrivateSellFormProps {
	readonly: boolean;
	onUpdated?: <T>( isValid: boolean, Data?: T ) => void;
	onFormLoad?: ( isLoading: boolean ) => void;
}

export interface IPrivateSellFormState {
	isValid: boolean;
}

export function handleDataUpdate<P extends IPrivateSellFormProps, S extends IPrivateSellFormState, D>
( oldData: D, newData: D, prevState: S, cmp: IPrivateSellForm<P, S> ) {
	if ( !_.isEqual( oldData, newData ) ) {
		const isValidNow = cmp.isValid( false );
		if ( prevState.isValid !== isValidNow ) {
			cmp.setState( { isValid: isValidNow }, () => {
				if ( cmp.props.onUpdated )
					cmp.props.onUpdated( isValidNow, newData );
			} );
		}
	}
}

export function ShowFormOnlyIf( props: Omit<FormFieldProps<any>, keyof ( { label: string } )> & { readonly: boolean, children?: any } ) {
	const v = readValue( props as FormFieldProps<any> );
	if ( !props.readonly ) return props.children;
	else if ( v != undefined ) return props.children;
	else return <div style={ { width: 0, height: 0, opacity: 0 } }>{ props.children }</div>;
}

// export function ShowReadOnlyIf(props: {children?: any, readonly : boolean}) {
//     if (props.readonly) return <div style={{width: 0, height: 0, opacity: 0}}>{props.children}</div>;
//     else return props.children;
// }

export function ShowOnlyIf( props: { valid: boolean, children?: any } ) {
	if ( props.valid ) return props.children;
	else return <div style={ { width: 0, height: 0, opacity: 0 } }/>;
}

export function FormContainer( props: { title: string, children?: any } ) {
	return <>
		<div className="section-title">
			<h5>{ props.title }</h5>
		</div>
		{ props.children }
	</>;
}
